// src/components/Sidebar.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { path: '/admin',           icon: '📊', label: 'Dashboard'          },
  { path: '/admin/orders',    icon: '📦', label: 'Orders'             },
  { path: '/admin/users',     icon: '👥', label: 'Users'              },
  { path: '/admin/pricing',   icon: '💰', label: 'Pricing & Validity' },
  { path: '/admin/webhooks',  icon: '🔔', label: 'Webhook Logs'       },
  { path: '/admin/qr-scans',  icon: '📱', label: 'QR Scans'           },
];

export default function Sidebar() {
  const { admin, logout } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const isActive = (path) => {
    if (path === '/admin') return location.pathname === '/admin';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <h2>🛡️ CivicSetu</h2>
        <span>Admin Panel</span>
      </div>

      <nav className="sidebar-nav">
        {navItems.map(item => (
          <button
            key={item.path}
            className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span className="icon">{item.icon}</span>
            {item.label}
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>
          {admin?.name || 'Admin'}
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          🚪 Logout
        </button>
      </div>
    </div>
  );
}
